import { Space, Tag } from "antd";
import { useMemo } from "react";
import { useTranslation } from "react-i18next";
import { type AllergenType } from "../gql/generated/graphqlSchema.tsx";

type AllergenTagListProps = {
  readonly allergens: readonly AllergenType[];
};

export const AllergenTagList = ({ allergens }: AllergenTagListProps) => {
  const { t, i18n } = useTranslation();

  const sorted = useMemo(
    () =>
      [...allergens]
        .map((key) => ({ key, label: t(`allergens.${key}`) }))
        .sort((a, b) => a.label.localeCompare(b.label, i18n.language)),
    [allergens, t, i18n.language],
  );

  if (sorted.length === 0) return null;

  return (
    <Space size={4} wrap>
      {sorted.map(({ key, label }) => (
        <Tag color="cyan" key={key}>
          {label}
        </Tag>
      ))}
    </Space>
  );
};
